export default __webpack_public_path__ + "static/RufusTaylor-1ab44ff8dc9120956821f02560bcb173.jpg";